import React from "react";
import DownloadAppSection from "./DownloadAppSection";
import SecondaryActionCard from "./SecondaryActionCard";

const FreeTrialComponent = ({
  isFreeTrialEnded,
  daysLeftToFreeTrialEnding,
  handleSignOut,
  handlePaymentProcess,
  isSubscribeNowClicked,
}) => {
  return (
    <section className="dashboard__container">
      {isFreeTrialEnded ? (
        <div
          className="dashboard__container__content__section__primary"
          style={{ backgroundColor: "#ff5145" }}
        >
          <h3 className="dashboard__container__content__section__primary__heading">
            {Math.abs(daysLeftToFreeTrialEnding)} Days before your free trial
            ended
          </h3>
          <button
            className="btn btn-md dashboard__container__content__section__primary__button"
            onClick={handlePaymentProcess}
          >
            {!isSubscribeNowClicked ? "Subscribe Now" : "Processing..."}
          </button>
        </div>
      ) : (
        <div className="dashboard__container__content__section__primary">
          <h3 className="dashboard__container__content__section__primary__heading">
            {daysLeftToFreeTrialEnding} Days to free trial end
          </h3>
        </div>
      )}

      {!isFreeTrialEnded && <DownloadAppSection />}

      {
        /**
         TODO: get webpage name from gym name and direct to it. We'll have to manually fill the website name
         */
      }

      <div className="dashboard__container__content">
        <SecondaryActionCard
          heading="View my website"
          subheading="See how it looks to the visitors"
          cta="Visit the website"
          link="/gym/abc"
        />

        <SecondaryActionCard
          heading="View The Product"
          subheading="Take the tour how our product helps you run your operations."
          cta="Take the tour"
          link="/showcase"
        />

        <SecondaryActionCard
          heading="Sales helps."
          subheading="Having issues understanding our product? Talk to our sales team."
          cta="Take to sales"
          link="tel:8072937581"
        />
      </div>

      <div className="dashboard__container__footer">
        <button
          className="btn btn-sm dashboard__container__footer__button"
          onClick={handleSignOut}
        >
          Log out
        </button>
      </div>
    </section>
  );
};

export default FreeTrialComponent;
